/**
 * Utility functions for Zoom UI
 */

/**
 * Creates a video placeholder with user initials
 * @param container - The container element to append the placeholder to
 * @param username - The username to display initials for
 * @param isMuted - Whether the user is muted
 */
export const createVideoPlaceholder = (
  container: HTMLElement,
  username: string,
  isMuted: boolean
): void => {
  if (!container) return;

  container.innerHTML = "";
  const placeholderDiv = document.createElement("div");
  placeholderDiv.id = "video-placeholder";
  placeholderDiv.style.width = "100%";
  placeholderDiv.style.height = "100%";
  placeholderDiv.style.backgroundColor = "#000000";
  placeholderDiv.style.display = "flex";
  placeholderDiv.style.alignItems = "center";
  placeholderDiv.style.justifyContent = "center";
  placeholderDiv.style.position = "relative";

  const initialsDiv = document.createElement("div");
  initialsDiv.style.width = "80px";
  initialsDiv.style.height = "80px";
  initialsDiv.style.borderRadius = "50%";
  initialsDiv.style.backgroundColor = "#037dba";
  initialsDiv.style.display = "flex";
  initialsDiv.style.alignItems = "center";
  initialsDiv.style.justifyContent = "center";
  initialsDiv.style.color = "white";
  initialsDiv.style.fontSize = "32px";
  initialsDiv.style.fontWeight = "600";
  initialsDiv.textContent = username.charAt(0).toUpperCase();

  placeholderDiv.appendChild(initialsDiv);

  container.appendChild(placeholderDiv);
};

/**
 * Attaches a video element to a container
 * @param mediaStream - The Zoom media stream
 * @param userId - The user ID to attach video for
 * @param container - The container element to append the video to
 * @returns Promise that resolves when video is attached
 */
export const attachVideoToContainer = async (
  mediaStream: any,
  userId: number,
  container: HTMLElement
): Promise<void> => {
  if (!container) return;

  try {
    // Clean up existing content
    container.innerHTML = "";

    // Attach new video
    const videoElement = await mediaStream.attachVideo(
      userId,
      window.WebVideoSDK.VideoQuality.Video_720P
    );

    if (videoElement instanceof HTMLElement) {
      videoElement.style.width = "100%";
      videoElement.style.height = "100%";
      videoElement.style.objectFit = "cover";
      container.appendChild(videoElement);
    }
  } catch (err) {
    console.error(`Failed to attach video for user ${userId}:`, err);
    throw err;
  }
};

export const isMobile = (() => {
  if (
    typeof navigator === "undefined" ||
    typeof navigator.userAgent !== "string"
  ) {
    return false;
  }
  return /Mobile/.test(navigator.userAgent);
})();
